import {
  CreateResourceTypeRolesPermissionsInput,
  FetchResourceAndPermissionByIdInput,
  UpdateResourceRoleMembersInput,
  UpdateResourceTypeRolesPermissionsInput,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const createResourceRolesPermissions = async (
  data: CreateResourceTypeRolesPermissionsInput
) => {
  try {
    const url = "/v1/controlCenter/resource_types";
    const response = await axiosClient.post(url, data);
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData.success &&
      responseData.statusCode === 200
    ) {
      return responseData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const fetchResourceRoleAndPermissionsById = async ({
  resource_type_id,
}: FetchResourceAndPermissionByIdInput) => {
  try {
    const url = `/v1/controlCenter/resource_types/${resource_type_id}`;
    const response = await axiosClient.get(url);
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData.success &&
      responseData.statusCode === 200
    ) {
      return responseData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateResourceRoleAndPermissionById = async ({
  resource_type_id,
  ...data
}: UpdateResourceTypeRolesPermissionsInput) => {
  try {
    const url = `/v1/controlCenter/resource_types/${resource_type_id}`;
    const response = await axiosClient.patch(url, {
      ...(data.resource_type_name && {
        resource_type_name: data.resource_type_name,
      }),
      ...(data.resource_type_description && {
        resource_type_description: data.resource_type_description,
      }),
      ...(data.permissions && {
        permissions: data.permissions,
      }),
      ...(data.customers && {
        customers: data.customers,
      }),
    });
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData.success &&
      responseData.statusCode === 200
    ) {
      return responseData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteResourceRoleAndPermissionById = async ({
  resource_type_id,
}: FetchResourceAndPermissionByIdInput) => {
  try {
    const url = `/v1/controlCenter/resource_types/${resource_type_id}`;
    const response = await axiosClient.delete(url);
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData.success &&
      responseData.statusCode === 200
    ) {
      return responseData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const fetchCurrentResourceRoleAndPermission = async () => {
  try {
    const url = "/v1/controlCenter/permissions";
    const response = await axiosClient.get(url);
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData.success &&
      responseData.statusCode === 200 &&
      responseData?.data
    ) {
      return responseData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateResourceRoleMembers = async ({
  resource_id,
  role_id,
}: UpdateResourceRoleMembersInput) => {
  try {
    const url = `/servicedesk/bulk/resource/${role_id}`;
    const response = await axiosClient.patch(url, {
      resource_id,
    });
    const responseData = response.data;
    if (
      response.status === 200 &&
      responseData.success &&
      responseData.statusCode === 200
    ) {
      return responseData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
